import { useLocalStorageWithSubscription } from "@sundae/react-hooks";
import { useWalletDetails } from "@sundae/wallet-react";
import { LOCAL_STORAGE_TASTE_TEST_TARGET_PRICE } from "../../../constants/localStorage.constants";
import { useTasteTestContext } from "../context";

type TTargetPrice = {
  [tasteTestId: string]: number;
};

const useTargetPrice = () => {
  const {
    state: { tasteTest },
  } = useTasteTestContext();
  const { details } = useWalletDetails();
  const [targetPrice, setTargetPrice] = useLocalStorageWithSubscription<TTargetPrice>(
    `${details.mainAddress}-${LOCAL_STORAGE_TASTE_TEST_TARGET_PRICE}`,
    {}
  );
  const activeTasteTestId = tasteTest?.slug;

  if (!activeTasteTestId) {
    return {
      targetPrice: 0,
      setTargetPrice,
    };
  }

  return {
    targetPrice: targetPrice[activeTasteTestId] || 0,
    setTargetPrice,
  };
};

export default useTargetPrice;
